import { render, staticRenderFns } from "./_AlternateBlock.vue?vue&type=template&id=a54fd7cc"
import script from "./_AlternateBlock.vue?vue&type=script&lang=js"
export * from "./_AlternateBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports